import React from 'react'
import { useNavigate } from 'react-router-dom'
import FlexyAlmacenSelect from './FlexyAlmacenSelect'
import FlexyTrasladoLineItems from './FlexyTrasladoLineItems'
import { useTrasladoForm } from '../hooks/useTrasladoForm'
import { ProductSearchInput } from '../../forms/shared'
import Button from '../../ui/Button/Button'

const FlexyTrasladoForm: React.FC = () => {
  const navigate = useNavigate()
  const {
    idalmacenOrigen,
    setIdalmacenOrigen,
    idalmacenDestino,
    setIdalmacenDestino,
    glosa,
    setGlosa,
    lineas,
    setLineas,
    isSubmitting,
    productDetails,
    loadingDetails,
    searchTerm,
    searchResults,
    isSearching,
    showResults,
    setShowResults,
    handleSearchChange,
    addProduct,
    submit
  } = useTrasladoForm()

  return (
    <form
      className="space-y-6"
      onSubmit={(event) => {
        event.preventDefault()
        submit()
      }}
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <FlexyAlmacenSelect
          id="traslado-origen"
          label="Almacén origen"
          value={idalmacenOrigen}
          onChange={setIdalmacenOrigen}
          excludeId={idalmacenDestino}
          disabled={isSubmitting}
        />
        <FlexyAlmacenSelect
          id="traslado-destino"
          label="Almacén destino"
          value={idalmacenDestino}
          onChange={setIdalmacenDestino}
          excludeId={idalmacenOrigen}
          disabled={isSubmitting}
        />
      </div>

      <div>
        <label htmlFor="traslado-glosa" className="block text-sm font-medium text-gray-700 mb-1">
          Glosa
        </label>
        <textarea
          id="traslado-glosa"
          value={glosa}
          onChange={(event) => setGlosa(event.target.value)}
          rows={3}
          disabled={isSubmitting}
          className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-custom-blue focus:outline-none focus:ring-1 focus:ring-custom-blue"
          placeholder="Descripción de la transferencia"
        />
      </div>

      <div className="space-y-3">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <h4 className="text-sm font-semibold text-gray-900">Productos</h4>
          <ProductSearchInput
            searchTerm={searchTerm}
            searchResults={searchResults}
            isSearching={isSearching}
            showResults={showResults}
            onSearchChange={handleSearchChange}
            onSelectProduct={addProduct}
            onFocus={() => setShowResults(true)}
            onBlur={() => setShowResults(false)}
            placeholder="Buscar producto por SKU o nombre"
            disabled={isSubmitting}
          />
        </div>

        <FlexyTrasladoLineItems
          lineas={lineas}
          onChange={setLineas}
          productDetails={productDetails}
          loadingDetails={loadingDetails}
          idalmacenOrigen={idalmacenOrigen}
          disabled={isSubmitting}
        />
      </div>

      <div className="flex flex-wrap gap-3 justify-end">
        <Button
          type="button"
          variant="secondary"
          onClick={() => navigate('/flexy/traslados')}
          disabled={isSubmitting}
        >
          Cancelar
        </Button>
        <Button type="submit" isLoading={isSubmitting}>
          Crear transferencia
        </Button>
      </div>
    </form>
  )
}

export default FlexyTrasladoForm
